var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSweatshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1260",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1264"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1272"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1266",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1270",
    clipPath: "url(#clipPath1274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1276",
    transform: "translate(338.8335,140.0332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -49.699 c 0,-9.15 -7.417,-16.568 -16.568,-16.568 H -149.1 c -9.15,0 -16.567,7.418 -16.567,16.568 V 0 l 33.134,33.133 h 99.399 z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1278"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1280",
    transform: "translate(371.9668,322.2666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -265.066 c 0,-9.15 -7.417,-16.568 -16.567,-16.568 h -198.799 c -9.15,0 -16.568,7.418 -16.568,16.568 V 0",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1282"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 355.4,40.633 H 156.6 V 7.5 h 198.8 z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1284"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1286",
    transform: "translate(89.1797,358.9072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -19.933,-23.193 -31.979,-53.36 -31.979,-86.34 l -0.001,-198.8 c 0,-9.151 7.418,-16.568 16.567,-16.568 h 49.7 c 9.15,0 16.567,7.417 16.567,16.568 v 248.499",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1288"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1290",
    transform: "translate(189.7334,405.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -29.4,0 -56.565,-9.573 -78.546,-25.772",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1292"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 123.467,57.2 h -49.7 V 24.067 h 49.7 z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1294"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1296",
    transform: "translate(90.3335,90.3335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -33.134",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1300",
    transform: "translate(322.2666,405.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 73.196,0 132.533,-59.337 132.533,-132.533 l 0.001,-198.8 c 0,-9.15 -7.418,-16.568 -16.568,-16.568 H 66.267 c -9.15,0 -16.567,7.418 -16.567,16.568 v 248.5",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1302"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 388.533,57.2 h 49.7 V 24.067 h -49.7 z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1304"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1306",
    transform: "translate(421.6665,90.3335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 33.134",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1310",
    transform: "translate(322.2666,405.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 27.449,0 49.7,22.251 49.7,49.7 49.7,77.148 27.449,99.4 0,99.4 h -132.533 c -27.449,0 -49.7,-22.252 -49.7,-49.7 0,-27.449 22.251,-49.7 49.7,-49.7 z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1312"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1314",
    transform: "translate(256,405.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,27.448 -22.251,49.7 -49.7,49.7 h -66.267",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1316"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1318",
    transform: "translate(256,405.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,27.448 22.251,49.7 49.7,49.7 h 66.267",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1320"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1322",
    transform: "translate(206.2998,421.6665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -66.267",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1324"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1326",
    transform: "translate(222.8667,338.8335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-9.15 -7.417,-16.567 -16.567,-16.567 -9.149,0 -16.566,7.417 -16.566,16.567 0,9.149 7.417,16.566 16.566,16.566 C -7.417,16.566 0,9.149 0,0 Z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1328"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1330",
    transform: "translate(305.7002,421.6665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -66.267",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1332"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1334",
    transform: "translate(322.2666,338.8335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-9.15 -7.417,-16.567 -16.566,-16.567 -9.15,0 -16.567,7.417 -16.567,16.567 0,9.149 7.417,16.566 16.567,16.566 C -7.417,16.566 0,9.149 0,0 Z",
    style: {
      fill: "none",
      stroke: "#0071bc",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1336"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSweatshirt);
export default __webpack_public_path__ + "static/media/icon-sweatshirt.b531cb67a36aea5818d21e1e1f77bfad.svg";
export { ForwardRef as ReactComponent };